import concurrencyRequest from './concurrency.request';
import createService from '../Utils/createService';
import handleServiceError from '../Utils/handleServiceError';
import { ServiceTypes } from '../Constants/api.constants';
import {
    RETRY_COUNT_API_SERVICE_CONCURRENCY,
} from '../../Errors/Constants/Error.retries';

const createConcurrencyService = (configStoreUpdate$, handleError) =>
    createService(
        ServiceTypes.CONCURRENCY,
        configStoreUpdate$,
        concurrencyRequest,
        handleServiceError(ServiceTypes.CONCURRENCY, handleError),
        RETRY_COUNT_API_SERVICE_CONCURRENCY,
    );

export default createConcurrencyService;
